export default __webpack_public_path__ + "static/media/market.00940257.jpg";